import {common} from './common';

export const environment = {
	production: false,
	development: false,
	version: common.version,
	googleMapsKey: 'AIzaSyDJWQ72Q9inJvS6yFkS7jRw2U15dQeQue4',
	googleMeasurementId: 'G-0ZJDGM8VNS',
	zendeskKey: '83879457-b489-4277-87f4-fea114103ff7', // Fellow's Zendesk key for d3v-fellow9842
	zeCurrentPageUrlFieldId: '41848861960979',  // Field Id for Custom regex field in d3v-fellow9842
	zeResetOnCloseTime: 60000, // When end user closes chat, milliseconds until reset of the chat window; 0 means we don't reset the widget
	// Used in dev environments to automatically login a given SSO user given an email address
	// and GUID from SubscriptionServices table. Format: `${email}&GUID=${GUID}`
	// DO NOT SET THIS TO ANYTHING OTHER THAN NULL IN NON DEV ENVIRONMENTS
	loginUser: null,
	base: 'https://test.fit.thinkfellow.com',
	apis: {
		error: 'https://test.fit.thinkfellow.com/Error/LogJavaScriptError',
		app: 'https://test.fit.thinkfellow.com/api',
		externalLGData: 'https://common.fit.thinkfellow.com/ExternalLGData/api/v2',
		externalCommonService: 'https://portal.sao.wa.gov/ExternalCommonservice/api',
		auditReports: 'https://www.sao.wa.gov/reports-data/audit-reports/'
	},
	reportAnIssueEmail: 'michelle.julien@thinkfellow.com'
};
